import { Injectable, signal, effect } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class NemThemeService {
  // Signal réactif pour le mode sombre
  isDarkMode = signal<boolean>(this.getInitialTheme());

  constructor() {
    // L'effet Angular s'exécute automatiquement chaque fois que isDarkMode change
    effect(() => {
      const isDark = this.isDarkMode();

      // 1. Sauvegarde la préférence
      localStorage.setItem('nem-theme', isDark ? 'dark' : 'light');

      // 2. Applique ou retire la classe 'dark' sur la balise <html>
      if (isDark) {
        document.documentElement.classList.add('dark');
      } else {
        document.documentElement.classList.remove('dark');
      }
    });
  }

  toggleTheme() {
    this.isDarkMode.update(dark => !dark);
  }

  private getInitialTheme(): boolean {
    const savedTheme = localStorage.getItem('nem-theme');
    if (savedTheme) {
      return savedTheme === 'dark';
    }
    // Si aucune préférence, on lit les paramètres du système de l'utilisateur
    return window.matchMedia('(prefers-color-scheme: dark)').matches;
  }
}
